import { reactive } from 'vue';
import { ApiResponse } from "@/entities/api-response";
import { LoggingService } from "@/services/logging.service";

export class ErrorHandlerService {
  state = reactive({
    errorMessage: 'Unknown Error',
  });

  public handleError(response: ApiResponse): void {
    // set the message if it exists
    this.state.errorMessage = response?.error?.message || 'Unknown Error';

    const logService = new LoggingService();
    logService.postLog({
      logLevel: 'error',
      message: this.state.errorMessage,
    });
  }
}

export const errorHandlerService = new ErrorHandlerService();
